<template>
	<CardGrafico :subtitle="updatedAt">
		<template #grafico>
			<Loading v-if="series.length === 0" />
			<div
				v-else
				class="container__grafico__dispersao"
			>
				<slot name="action-buttons" />
				<Chart
					id="dispersao__parcelas"
					ref="chartExample"
					:update-args="[chartOptions, true]"
					:options="chartOptions"
				/>
			</div>
		</template>
	</CardGrafico>
</template>

<script>
import { Chart } from 'highcharts-vue'
import Loading from '../../components/Loading/Loading'
import CardGrafico from '../CardGrafico/CardGrafico'

// import _ from "lodash";

import { stringToExportCSV } from '../../utils/csvHellpers'

export default {
	components: { CardGrafico, Loading, Chart },
	props: {
		/**
		 * Dados que devem ir para o grafico
		 */

		xTitulo: { type: String, default: '' },
		altXTitulo: { type: String, default: '' },
		yTitulo: { type: String, default: '' },
		titulo: { type: String, default: '' },
		series: { type: Array, required: true },
		updatedAt: { type: String, required: false, default: '' },
	},
	data() {
		return {
			dropdownTipoGrafico: 'vtcc',
			dropdownDownload: '',
			array: [],
			array2: [],
			parcelasTemporarias: [],
			chartScopes: [
				{ label: 'Altura Dominante', value: 'alturaDominante' },
				{ label: 'VTCC', value: 'vtcc' },
				{ label: 'VTSC', value: 'vtsc' },
				{ label: 'Área Basal', value: 'areaBasal' },
				{ label: 'Diâmetro Médio', value: 'diametroMedio' },
			],
		}
	},

	computed: {
		dados() {
			return this.series.map((e) => {
				return {
					x: Number(e[0]),
					y: e[2],
					value: e[1],
					name: 'valor',
					color: `rgb(149, 187, 73)`,
				}
			})
		},
		/**
		 * Options para configuracao do grafico
		 */
		chartOptions() {
			return {
				chart: {
					type: 'column',
					zoomType: 'xy',
					// redraw: true
				},
				lang: {
					resetZoom: 'Resetar zoom',
				},
				title: {
					text: this.titulo,

					style: {
						fontSize: '100%',
					},
				},
				subtitle: {
					text: '',
				},

				xAxis: [
					{},
					{
						tickInterval: 1,
						title: {
							text: this.xTitulo,
							style: {
								fontSize: '100%',
							},
						},
					},
				],

				yAxis: [
					{
						labels: {
							format: '{value}%',
						},
						title: {
							text: this.yTitulo,
						},

						endOnTick: false,
					},
					{
						title: {
							text: null,
							style: {
								fontSize: '100%',
							},
						},
					},
				],

				legend: {
					enabled: false,
				},
				tooltip: {
					positioner: function () {
						return { x: 40, y: 25 }
					},
					headerFormat: '<b>{point.codigoParcela}</b><br>',
					pointFormat:
						(this.altXTitulo || this.xTitulo) +
						': {point.x:.2f}<br>' +
						'Porcentagem: ' +
						'{point.y:.2f}%<br>' +
						'Quantidade: ' +
						'{point.value} ',
				},

				series: [
					{
						data: this.dados,
					},
				],

				// series: [{
				//     name: 'Parcela',
				//     // data: this.data.map(e => { return {x: e.idade, y: e.vtcc }})
				//     color: `rgb(149, 187, 73)`,
				//     data: this.dadosDispersao
				// }]
			}
		},

		/**
		 * Prepara os dados para serem plotadas no grafico de dispersao
		 */

		/**
		 * Configuracao do grafico de acordo com o tipo exibido
		 */
		configuracaoDoGrafico() {
			if (this.dropdownTipoGrafico === 'vtcc') {
				return {
					tipoDoGrafico: this.$t('volumeComCasca'),
					titulo: this.$t('volumeComCascaFaixaIdade'),
					posicaoDataLabel: -35,
				}
			} else if (this.dropdownTipoGrafico === 'vtsc') {
				return {
					tipoDoGrafico: this.$t('volumeSemCasca'),
					titulo: this.$t('volumeSemCascaFaixaIdade'),
					posicaoDataLabel: -35,
				}
			} else if (this.dropdownTipoGrafico === 'alturaDominante') {
				return {
					tipoDoGrafico: 'Altura Dominante',
					titulo: this.$t('alturaDominanteFaixaIdade'),
					posicaoDataLabel: -35,
				}
			} else if (this.dropdownTipoGrafico === 'areaBasal') {
				return {
					tipoDoGrafico: 'Área Basal',
					titulo: this.$t('areaBasalFaixaIdade'),
					posicaoDataLabel: -35,
				}
			} else {
				return {
					tipoDoGrafico: 'Diâmetro Médio',
					titulo: this.$t('diametroMedioFaixaIdade'),
					posicaoDataLabel: -55,
				}
			}
		},
	},
	watch: {
		/**
		 * Sempre que o data mudar ira renderizar o grafico novo
		 */
		series() {
			console.log('mudou! coluna', this.series)
			// this.changeHighchartsOptions();
		},
		/**
		 * Tipo do grafico que deve ser mostrado
		 * Área Plantada, Volume ou IMA
		 */
		dropdownTipoGrafico() {
			this.changeHighchartsOptions()
			this.$emit('tipoGrafico', this.dropdownTipoGrafico)
		},
		/**
		 * Seleciona a opcao de download escolhida
		 */
		dropdownDownload(type) {
			if (type) {
				const filename = `${new Date().getTime()}`
				if (type === 'text/csv') {
					const csv = this.$refs.chartExample.chart.getCSV()
					stringToExportCSV(filename, csv)
				} else {
					this.$refs.chartExample.chart.exportChart({ filename, type })
				}
				this.dropdownDownload = ''
			}
		},
	},
	created() {
		console.log('dadosDispersao', this.dadosDispersao)
		console.log('chart', this.$refs.chartExample)

		const rgbDefaultColor = getComputedStyle(document.body).getPropertyValue('--color-default')
		this.chartOptions.series[0].color = `rgb(${rgbDefaultColor})`
	},

	methods: {
		/**
		 * Seta os dados do grafico de acordo com o valor que estiver no dropdown
		 */
		changeHighchartsOptions() {
			console.log(this.dropdownTipoGrafico)
			// const sortedData = _.orderBy(this.series, this.dropdownTipoGrafico, [
			//   "desc",
			// ]);

			// let opacity = 1;
			// const opacityDecrease = 0.7 / sortedData.length;

			// const data = sortedData.map((dadosPorIdade) => {
			//   const result = {
			//     y: dadosPorIdade[this.dropdownTipoGrafico],
			//     opacity,
			//     tooltipData: dadosPorIdade,
			//   };
			//   opacity -= opacityDecrease;
			//   return result;
			// });

			// const categories = sortedData.map((value) => {
			//   return value.faixaDeIdade;
			// });

			// this.chartOptions.series[0].data = data;
			// this.chartOptions.xAxis.categories = categories;
			// this.chartOptions.yAxis.title.text = this.configuracaoDoGrafico.tipoDoGrafico;
		},
	},
}
</script>

<style scoped>
/* @import url("../../css/tooltipSimplesHighcharts.css"); */
.container__grafico__dispersao {
	display: block;
	flex-direction: column;
	height: 100%;
}

.highcharts-container {
	margin: 0 !important;
	height: 100% !important;
}

#dispersao__parcelas {
	height: 100%;
}
</style>
